import React, { FC } from "react";

import { IconProps } from "..";

import "../Icon.css";

export const IconPython: FC<IconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className="Icon IconPython"
  >
    <path d="M11.935 3c-4.57 0-4.284 1.992-4.284 1.992l.005 2.064h4.36v.62H5.925S3 7.341 3 11.975c0 4.636 2.552 4.471 2.552 4.471h1.523v-2.15s-.082-2.566 2.512-2.566h4.325s2.43.04 2.43-2.36V5.4S16.71 3 11.934 3zM9.531 4.388c.434 0 .784.352.784.788 0 .436-.35.789-.784.789a.786.786 0 01-.785-.789c0-.436.35-.788.785-.788z" />
    <path d="M12.065 21c4.57 0 4.284-1.992 4.284-1.992l-.005-2.064h-4.36v-.62h6.092s2.924.334 2.924-4.3c0-4.636-2.552-4.471-2.552-4.471h-1.523v2.15s.082 2.566-2.512 2.566h-4.325s-2.43-.04-2.43 2.36v3.97S7.29 21 12.065 21zm2.404-1.388a.786.786 0 01-.784-.788c0-.437.35-.789.784-.789.434 0 .785.352.785.789 0 .436-.35.788-.785.788z" />
  </svg>
);
